package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMay82022StrAIberryChartChallengesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/may82022StrAIberryChartChallenges.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/may82022-str-a-iberry-chart-challenges")
@Composable
fun May82022StrAIberryChartChallengesPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("may-8-2022-straiberry-chart-challenges") }) {
        org.jetbrains.compose.web.dom.Text("may-8-2022-StrAIberry-chart-challenges")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At home page we had 4 kind of charts. The overall purpose of this charts was to show an average health/whitening of users oral hygiene. Charts layout was challenging but they are sincerely beautiful. After a couple of R&D we found no library that looks like our design, so we needed to go custom.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Looking at the chart form above, they seamed quite difficult to create, but a problem solving mind will always divides a big problem into smaller ones. I usually start with the easy one, it keeps me motivated during the process.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our main tool was Canva. But first we extracted the data models for our charts. This models are needed to feed the charts & extracting them was a good starter point for charts overall structure.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Then we extracted the views. Each chart was giving a unique name, Each individual part of the chart should be an individual view and then gets combined in the main chart view. For example our ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("WhiteningChart")
        }
        org.jetbrains.compose.web.dom.Text(" divided into two smaller views, the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("bars")
        }
        org.jetbrains.compose.web.dom.Text(" and the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("floating_score")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Charts had also some similar views, for example the x/y bars was similar in two of them.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I also proposed to convert this charts into a library for android. This text will be updated when its ready.")
    }
}
